<template>
    <div id="g-recaptcha"></div>
</template>

<script>
import { computed, ref } from '@vue/reactivity'
import { onMounted, watch } from '@vue/runtime-core'
export default {
    props: ['submit'],
    setup(props, context) {
        const recaptchaKey = computed(() => process.env.VUE_APP_RECAPTCHA_KEY)
        const recaptcha = ref(null)

        onMounted(() => {
            if (window.grecaptcha == null) {
                new Promise((resolve) => {
                    window.recaptchaReady = function () {
                        resolve();
                    };
                    const doc = window.document;
                    const scriptId = "recaptcha-script";
                    const scriptTag = doc.createElement("script");
                    scriptTag.id = scriptId;
                    scriptTag.setAttribute("src", `https://www.google.com/recaptcha/api.js?onload=recaptchaReady`);
                    document.getElementsByTagName('body').item(0).appendChild(scriptTag)
                }).then(() => {
                    renderRecaptcha()
                });
            } else if(!recaptcha.value) {
                renderRecaptcha()
            }
        })

        const renderRecaptcha = () => {
            recaptcha.value = grecaptcha.render('g-recaptcha', {
                'sitekey': recaptchaKey.value,
                'size': 'invisible',
                'callback': (token) => {
                    context.emit("callback", token)
                },
                'expired-callback': () => reset(),
                'error-callback': () => {}
            });
        }

        const execute = () => {
            grecaptcha.execute(recaptcha.value)
        }

        const reset = () => {
            grecaptcha.reset(recaptcha.value);
        }

        return {recaptchaKey, execute, reset}
    },
}
</script>
